<form [formGroup]="vm" *ngIf="!showDetail">
    <n-form-item [labelHide]="true">
        <div class="title-md mt-32">
            <span id='unix_permission_title'>{{str.unixPermissionTitle[entryType]}}</span>
        </div>
    </n-form-item>
    <n-card-panel class="unix-permisssion-card-panel">
        <!-- 用户 -->
        <n-form-item [label]="str.i18n.unixPermissions.userLab" [helpContent]="str.i18n.unixPermissions.userHelpContent">
            <n-checkbox-group formControlName="user">
                <n-checkbox [id]="'unix_permission_user_' + unixPermissionOption.value" *ngFor="let unixPermissionOption of str.unixPermissionOptions" [label]="unixPermissionOption.label" [value]="unixPermissionOption.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
        <!-- 用户组 -->
        <n-form-item [label]="str.i18n.unixPermissions.userGroupLab" [helpContent]="str.i18n.unixPermissions.userGroupHelpContent">
            <n-checkbox-group formControlName="userGroup">
                <n-checkbox [id]="'unix_permission_userGroup_' + unixPermissionOption.value" *ngFor="let unixPermissionOption of str.unixPermissionOptions" [label]="unixPermissionOption.label" [value]="unixPermissionOption.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
        <!-- 其他 -->
        <n-form-item [label]="str.i18n.unixPermissions.otherLab" [helpContent]="str.i18n.unixPermissions.otherHelpContent">
            <n-checkbox-group formControlName="other">
                <n-checkbox [id]="'unix_permission_other_' + unixPermissionOption.value" *ngFor="let unixPermissionOption of str.unixPermissionOptions" [label]="unixPermissionOption.label" [value]="unixPermissionOption.value">
                </n-checkbox>
            </n-checkbox-group>
        </n-form-item>
    </n-card-panel>
</form>
<!-- 详情页展示 -->
<n-block id='unix_permission_detail' *ngIf="!isEmpty && showDetail" class="unix-permisssion-block">
    <n-lv [colcount]="1">
        <!-- 用户 -->
        <n-lv-item [label]="str.i18n.unixPermissions.userLab" *ngIf="!isUserEmpty">
            <span class="unix-tip" *ngFor="let unixPermission of vm.value?.user">{{ str.unixPermissionLabel[unixPermission] }}</span>
        </n-lv-item>
        <!-- 用户组 -->
        <n-lv-item [label]="str.i18n.unixPermissions.userGroupLab" *ngIf="!isGroupEmpty">
            <span class="unix-tip" *ngFor="let unixPermission of vm.value?.userGroup">{{ str.unixPermissionLabel[unixPermission] }}</span>
        </n-lv-item>
        <!-- 其他 -->
        <n-lv-item [label]="str.i18n.unixPermissions.otherLab" *ngIf="!isOtherEmpty">
            <span class="unix-tip" *ngFor="let unixPermission of vm.value?.other">{{ str.unixPermissionLabel[unixPermission] }}</span>
        </n-lv-item>
    </n-lv>
</n-block>